import { useMutation, type UseMutationResult, useQueryClient } from '@tanstack/react-query';
import type { OperationLinkInput } from '../../model/operation-link.js';
import { linkOperation } from '../requests/link-operation.js';
import { refreshAfterFailedLink, refreshAfterLink } from './bank-transaction-cache.js';

export const useLinkOperationMutation = (): UseMutationResult<void, Error, OperationLinkInput> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: linkOperation,
    onSuccess: (_result, input) => refreshAfterLink(queryClient, input.operationId),
    onError: () => refreshAfterFailedLink(queryClient),
  });
};
